import Input from '@/components/ui/input/input';
export default Input;
